import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ... {
            resource: 'teachers',

        getTeachersForTimetable(params = null) {
            return ApiService.post(`/${this.resource}/get-teachers-for-timetable`, params)
        },
        getTeacherAttendance(params) {
            return ApiService.get("attendance/teacher", params);
        },
        updateProfile(params = null) {
            return ApiService.post(`/${this.resource}/profile/${params.teacher.id}`, params)
        },

        getReminders(teacherID, params = null) {
            return ApiService.get(`/${this.resource}/get-reminders/${teacherID}`, params)
        },

        getClassesAndGroups(teacherID, params = null) {
            return ApiService.get(`/${this.resource}/get-classes-groups/${teacherID}`, params)
        },
        syncAdminRole(teacherID) {
            return ApiService.post(`/${this.resource}/sync-admin-role/${teacherID}`)
        },
        syncTeamsTeacher(teacherId) {
            return ApiService.post(`/${this.resource}/sync-one`, {
                teacher_id: teacherId
            })
        },

        /**
         * Create a Teams meeting for a time table slot
         * @param {number} slotId - Time table slot ID
         * @param {string} date - Date in YYYY-MM-DD format
         * @returns {Promise}
         */
        createTimeTableSlotMeeting(slotId, date) {
            return ApiService.post(`/time-table-slots/${slotId}/create-meeting`, {
                date: date
            })
        },

        /**
         * Get meeting URL for a time table slot and date
         * @param {number} slotId - Time table slot ID
         * @param {string} date - Date in YYYY-MM-DD format
         * @returns {Promise}
         */
        getTimeTableSlotMeetingUrl(slotId, date) {
            return ApiService.get(`/time-table-slots/${slotId}/meeting-url`, {
                date: date
            })
        },

    }
}